export default __webpack_public_path__ + "images/5caf2b13e2aaaa9d70658297a47606fe.svg";